<!--
 * @Author: benaozhi
 * @Date: 2020-07-30 18:32:36
 * @LastEditTime: 2022-02-10 23:47:02
 * @Description:
-->
<template>
  <div class="loginPage">
    <div class="loginWrap">
      <!-- logo -->
      <img class="loginLogo" src="@/render/assets/images/login_logo.png" />
      <!-- 登录框 -->
      <login-form
        @submit="onLogin"
        @onRegister="handleRegister"
        @onForget="handleForget"
        :data="loginInfo"
      />
    </div>
  </div>
</template>

<script>
import store from 'store'
import { LOGIN_INFO, USER_INFO } from '@/config/const'
import authUtil from '@/render/utils/auth'
import LoginForm from './components/LoginForm'

export default {
  name: 'LoginPage',
  props: {},
  data() {
    return {
      message: '',
      loginInfo: { username: '', password: '' },
    }
  },
  components: { LoginForm },
  computed: {},
  async mounted() {
    this.initLoginInfo()
  },
  methods: {
    initLoginInfo() {
      const loginInfo = store.get(LOGIN_INFO)
      if (loginInfo) this.loginInfo = loginInfo
    },
    async onLogin(payload) {
      const { ...params } = payload
      const { code, data } = await this.$store.dispatch('auth/login', params)
      authUtil.setToken(data.token)
      store.set(USER_INFO, data)
      this.$message({
        message: '登录成功',
        type: 'success',
      })
      setTimeout(() => {
        this.$router.push('/home')
      })
    },
    handleRegister() {
      this.$router.push('/register')
    },
    handleForget() {
      this.$router.push('/forget')
    },
  },
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
